import React from 'react'
import { connect } from 'react-redux'
import { userTokenSelector } from 'Store/customer/selector'
import { RootState } from 'Store'
import { Col, Row } from 'antd'
import styled from 'styled-components'
import Theme, { MyTheme } from 'Components/common/Theme'
import { selectCurrentUser } from 'Store/user/selector'
import { numberWithComma, renderMonth } from 'helpers/format'
import { Bar } from 'Components/utilities/Chart'
import { monthNames } from 'helpers/constanst'
import { ProductivityByMonthData } from 'Store/minirmx-dashboard/types'

type Props = {
  datas: ProductivityByMonthData[]
} & ReduxProps

const ManufacPermonthReport: React.FunctionComponent<Props> = props => {
  const months = renderMonth()

  const { datas } = props

  const getGraphtData = () => {
    const labels = [] as string[]
    const values = [] as number[]
    datas &&
      datas.forEach((item: ProductivityByMonthData) => {
        labels.push(item.mon)
        values.push(item.quantity)
      })

    return { labels, values }
  }

  const result = getGraphtData()
  const data = {
    labels: result.labels,
    datasets: [
      {
        label: 'ยอดขาย',
        data: result.values,
        fill: false,
        backgroundColor: Theme.colors.primary,
        borderColor: Theme.colors.primary,
        tension: 0,
        borderWidth: 2,
      },
    ],
  }

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem: any, data: any) => {
          const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || 0
          return `จำนวน ${numberWithComma(value)} คิว`
        },
      },
    },
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <BoxTitle>จำนวนการผลิตแบ่งตามรายเดือน (คิว)</BoxTitle>
      </Col>
      <Col md={24} xs={24}>
        <BoxWrapper>
          <Row justify="start" align="bottom">
            <Col span={24}>
              <Bar data={data} options={options} />
            </Col>
          </Row>
        </BoxWrapper>
      </Col>
    </Row>
  )
}

const BoxWrapper = styled.div`
  padding: 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border-radius: 10px;
  border-color: transparent;
`

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
`

const mapStateToProps = (state: RootState) => {
  return {
    token: userTokenSelector(state),
    currentUser: selectCurrentUser(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ManufacPermonthReport)
